import React, {FC, useEffect, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import SignaturePad from 'react-signature-pad-wrapper'
import Swal from 'sweetalert2'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {
  createCheckinService,
  createCheckoutService,
  uploadSignatureGuestService,
} from '../../../services/checking.service'
import {ModalPreviousCheckout} from '../components/ModalPreviousCheckout'
import {getTermsService} from '../../tyc/services'
import {downloadPDFCheckInOutService} from '../../../services/booking.service'
import {getSnackBarToast} from '../../../../../util/snackBar'
import {ShowSnackBar} from '../../../../../util/functions'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep3: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    // register,
    setValue,
    watch,
    // control,
    // formState: {errors},
    // setError,
  } = useFormContext()

  // const [isChekingTyc, setIsChekingTyc] = useState(true)
  const signaturePadRef = React.createRef<SignaturePad>()
  const [isLoadingResult, setIsLoadingResult] = useState(false)
  // const [tycText, setTycText] = useState('')
  // const [hasTyc, setHasTyC] = useState(false)
  const [isLoadingCheck, setIsLoadingCheck] = useState(false)

  // Modal de checkout de reserva anterior (cuando existen 2+ reservas en checkout)
  const [showPreviousModal, setShowPreviousModal] = useState(false)
  const [isModalLoading, setIsModalLoading] = useState(false)
  const [currentBookingData, setCurrentBookingData] = useState<any>(null)
  const [previousBookingData, setPreviousBookingData] = useState<any>(null)

  const tipoDocumento_descripcion = useWatch({name: 'tipoDocumento_descripcion'})
  const numeroDocumento = useWatch({name: 'numeroDocumento'})
  // const [timerI, setTimer] = useState(20)
  const bookingItem = useWatch({name: 'bookingItem'})
  // const isGuest = useWatch({name: 'isGuest'})
  // const modAutoservicioTotem = useWatch({name: 'ModAutoservicioTotem'})
  const operationType = useWatch({name: 'operationType'})
  const huespedId = useWatch({name: 'HuespedId'})
  const reservaId = useWatch({name: 'ReservaId'})
  const camaId = useWatch({name: 'CamaId'})
  // const aceptaTyC = useWatch({name: 'AceptaTyC'})
  // const companiaId = useWatch({name: 'CompaniaId'})
  // const clienteId = useWatch({name: 'ClienteId'})
  // const siteId = useWatch({name: 'SiteId'})
  const reservaCamaId = useWatch({name: 'ReservaCamaId'})
  const Estado = useWatch({name: 'Estado'})
  const loadingBooking = useWatch({name: 'loadingBooking'})
  const hasBookings = useWatch({name: 'hasBookings'})
  const previousBooking = useWatch({name: 'previousBooking'})

  // useEffect(() => {
  //   // Start the timer countdown when the component mounts
  //   // const intervalId = setInterval(() => {
  //   //   setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0))
  //   // }, 1000)

  //   if (!aceptaTyC && isGuest && huespedId) {
  //     handlePaginationTerms()
  //     // setTimer(60)
  //   } else {
  //     // setIsChekingTyc(false)
  //   }

  //   // Clean up the interval when the component unmounts
  //   // return () => clearInterval(intervalId)
  // }, [])

  // useEffect(() => {
  //   // Perform an action when the timer reaches 0
  //   if (timerI === 0) {
  //     if (!aceptaTyC) {
  //       ShowQuestionTimmer()
  //     } else {
  //       // Assuming you have access to stepper.current in the scope of this component
  //       // Replace this with your actual logic to go to step 1
  //       //   stepper.current.goto(1)
  //       goToFirstStep()
  //     }
  //   }
  // }, [timerI])

  const handleSubmit = async () => {
    if (operationType === 'checkin') {
      handleCheckIn()
    } else {
      handleCheckout()
    }
  }

  const handleCheckIn = async () => {
    try {
      setIsLoadingCheck(true)
      const {data: response} = await createCheckinService({
        ReservaId: reservaId,
        CamaId: camaId,
        HuespedId: huespedId,
      })
      if (response.error) {
        await setValue('errorCheck', true)
        getSnackBarToast(response.message, 'error')
        setValue('fromFinish', false)
        nextStep()
        setIsLoadingCheck(false)
        return
      }
      setIsLoadingCheck(false)
      setValue('fromFinish', false)
      nextStep()
      if (Estado !== 'PRECHECKIN') {
        let dto = {
          reservaCamaId: reservaCamaId,
          tipo: 'IN',
          MotivoReimpresionId: '',
          Otros: '',
        }
        const resp = await downloadPDFCheckInOutService(dto)
        const blob = new Blob([resp.data], {type: 'application/pdf'})
        let url = window.URL.createObjectURL(blob)
        setTimeout(() => {
          printPdf(url)
        }, 1000)
        Swal.fire({
          title: 'Se ha realizado el check-in',
          html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket Checkin</button>
            </div>`,
          icon: 'success',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          didOpen: () => {
            const printButton = document.getElementById('printButton') as HTMLElement
            printButton.addEventListener('click', () => printPdf(url))
          },
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.close()
          }
        })
      }
    } catch (error: any) {
      getSnackBarToast(error?.response?.message, 'error')
    }
  }

  const printPdf = (pdfUrl: any) => {
    const printWindow = window.open(pdfUrl, '_blank')
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
      })
    }
  }

  const handlePrintCheckin = async () => {
    try {
      let dto = {
        reservaCamaId: reservaCamaId,
        tipo: 'IN',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const resp = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([resp.data], {type: 'application/pdf'})
      let url = window.URL.createObjectURL(blob)
      setTimeout(() => {
        printPdf(url)
      }, 1000)
    } catch (error) {
      ShowSnackBar('No hemos podido generar el PDF', 'error')
    }
  }

  const handlePrintCheckout = async () => {
    try {
      let dto = {
        reservaCamaId: reservaCamaId,
        tipo: 'OUT',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const resp = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([resp.data], {type: 'application/pdf'})
      let url = window.URL.createObjectURL(blob)
      setTimeout(() => {
        printPdf(url)
      }, 1000)
    } catch (error) {
      ShowSnackBar('No hemos podido generar el PDF', 'error')
    }
  }

  const handleCheckout = async () => {
    try {
      setIsLoadingCheck(true)
      const {data: response} = await createCheckoutService({
        ReservaId: reservaId,
        CamaId: camaId,
        HuespedId: huespedId,
      })

      if (response.error) {
        setValue('errorCheck', true)
        getSnackBarToast(response.message, 'error')
        setIsLoadingCheck(false)
        setValue('fromFinish', false)
        nextStep()
        return
      }

      // Si en el paso 2 postListBeds devolvió 2 reservas (previousBooking cargado),
      // tras ejecutar el checkout se levanta el modal de checkout de la reserva anterior.
      if (previousBooking) {
        setCurrentBookingData(bookingItem)
        setPreviousBookingData(previousBooking)
        setIsLoadingCheck(false)
        setShowPreviousModal(true)
        return
      }

      setIsLoadingCheck(false)
      setValue('fromFinish', false)
      nextStep()
      // let dto = {
      //   reservaCamaId: reservaCamaId,
      //   tipo: 'OUT',
      //   MotivoReimpresionId: '',
      //   Otros: '',
      // }
      // const resp = await downloadPDFCheckInOutService(dto)
      // const blob = new Blob([resp.data], {type: 'application/pdf'})
      // let url = window.URL.createObjectURL(blob)
      // setTimeout(() => {
      //   printPdf(url)
      // }, 1000)
      // Swal.fire({
      //   title: 'Se ha realizado el check-out',
      //   html: `<div id="print_pdf">
      //         <button
      //           id='printButton'
      //           class='sdx_btn m-auto'
      //           type='button'
      //         >Imprimir Ticket Checkout</button>
      //       </div>`,
      //   icon: 'success',
      //   showLoaderOnConfirm: true,
      //   allowOutsideClick: () => !Swal.isLoading(),
      //   didOpen: () => {
      //     const printButton = document.getElementById('printButton') as HTMLElement
      //     printButton.addEventListener('click', () => printPdf(url))
      //   },
      // }).then(async (result) => {
      //   /* Read more about isConfirmed, isDenied below */
      //   if (result.isConfirmed) {
      //     Swal.close()
      //   }
      // })
    } catch (error) {
      // Handle error
    }
  }

  // "No" / cerrar: el checkout actual ya se realizó, se continúa al paso de éxito.
  const handleClosePreviousModal = () => {
    setShowPreviousModal(false)
    setValue('fromFinish', false)
    nextStep()
  }

  // "Sí, realizar checkout": usa el mismo servicio de checkout que el botón principal,
  // enviando la info de la reserva anterior + la fecha elegida en el input.
  const handleConfirmPreviousCheckout = async (fechaCheckout: string) => {
    try {
      setIsModalLoading(true)
      const {data: response} = await createCheckoutService({
        ReservaId: previousBookingData?.ReservaId,
        CamaId: previousBookingData?.CamaId,
        HuespedId: previousBookingData?.HuespedId,
        FechaCheckOut: fechaCheckout,
      })
      if (response.error) {
        getSnackBarToast(response.message, 'error')
        setIsModalLoading(false)
        return
      }
      setIsModalLoading(false)
      setShowPreviousModal(false)
      setValue('fromFinish', false)
      nextStep()
    } catch (error) {
      setIsModalLoading(false)
    }
  }

  const handleGoStep2 = async () => {
    goToStep(2)
  }

  // const handlePaginationTerms = async () => {
  // const {data: response} = await getTermsService({
  //   CompaniaId: companiaId,
  //   ClienteId: clienteId,
  //   SiteId: siteId,
  //   pageNumber: 1,
  //   size: 10,
  // })
  // if (!response.error && response.data.length > 0 && response.data[0].TyC) {
  //   if (response.data[0].ModAutoservicioTotem) {
  //     setTycText(response.data[0].TyC)
  //     setHasTyC(true)
  //   } else {
  //     setHasTyC(false)
  //     // await setValue('AceptaTyC', true) // No se le permite firmar TyC
  //     //@todo("Poner Loading");
  //   }
  // } else {
  //   setHasTyC(false)
  // }
  // setIsChekingTyc(false)
  // }

  // const ShowQuestionTimmer = async () => {
  //   let timerInterval: any = null
  //   Swal.fire({
  //     confirmButtonText: 'Si',
  //     didOpen: () => {
  //       //Swal.showLoading();
  //       // const timer = Swal.getPopup().querySelector("b");
  //       // timerInterval = setInterval(() => {
  //       //   timer.textContent = `${Swal.getTimerLeft()}`;
  //       // }, 100);
  //     },
  //     showConfirmButton: true,
  //     //  showDenyButton:true,
  //     //html: "I will close in <b></b> milliseconds.",
  //     timer: 5000,
  //     timerProgressBar: true,
  //     title: '¿Sigues ahí?',
  //     willClose: () => {
  //       clearInterval(timerInterval)
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setTimer(60)
  //     } else {
  //       goToFirstStep()
  //     }
  //     /* Read more about handling dismissals below */
  //     // if (result.dismiss === Swal.DismissReason.timer) {
  //     // }
  //   })
  // }

  const handleClearSignature = async () => {
    const signaturePad = signaturePadRef.current
    signaturePad?.clear()
  }

  const handleSaveSing = async () => {
    const signaturePad = signaturePadRef.current

    if (!signaturePad) {
      return
    }

    if (signaturePad.isEmpty()) {
      // eslint-disable-next-line no-alert
      Swal.fire('El huesped debe firmar primero.', '', 'warning')
    } else {
      setIsLoadingResult(true)
      let imageValue = signaturePad.toDataURL()
      const binaryData = atob(imageValue.replace('data:image/png;base64,', ''))
      const arrayBuffer = new ArrayBuffer(binaryData.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i)
      }
      //window.open(signaturePad.toDataURL());
      const blob = new Blob([uint8Array])
      const formData = new FormData()
      formData.append('file', blob, `Firma-${huespedId}.png`)

      const response = await uploadSignatureGuestService(formData, huespedId)
      setIsLoadingResult(false)
      if (!response.data.error) {
        handleSubmit()
      } else {
        Swal.fire('No hemos podido guardar la firma', 'Intentalo nuevamente', 'error')
        //handleExit();
      }
    }
  }

  console.log({huespedId})

  return (
    <div className='w-100'>
      <>
        {/* <div className='mt-3'>
            <p>
              Tiempo restante: <span>{timerI}</span> segundos
            </p>
          </div> */}
        {loadingBooking ? (
          <div className='d-flex justify-content-center flex-column align-items-center'>
            <div className='d-flex flex-column align-items-center mt-3'>
              <span className='indicator-progress' style={{display: 'block'}}>
                Verificando...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            </div>
          </div>
        ) : (
          <>
            {!hasBookings ? (
              <div className='d-flex justify-content-center flex-column align-items-center'>
                <div>
                  <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
                </div>
                <div className='d-flex flex-column align-items-center mt-3'>
                  <div className='fs-1 fw-bolder'>No se encontraron reservas activas</div>
                </div>
              </div>
            ) : (
              <>
                {hasBookings && huespedId ? (
                  <div className='row'>
                    <div>
                      <span className='fw-bold fs-6'>Tipo de Documento: </span>
                      <span className='fs-6'>{tipoDocumento_descripcion}</span>
                    </div>
                    <div className='mb-5'>
                      <span className='fw-bold fs-6'>Numero de Documento: </span>
                      <span className='fs-6'>{numeroDocumento}</span>
                    </div>
                    <div className='fw-bold fs-5 mb-5'>Detalles de Reserva</div>
                    <div>
                      <span className='fw-bold fs-6'>Nombres: </span>
                      <span className='fs-6'>{bookingItem?.HuespedDescripcion}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Empresa: </span>
                      <span className='fs-6'>{bookingItem?.RazonSocialSubContratista}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Site: </span>
                      <span className='fs-6'>{bookingItem?.Site}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Campamento: </span>
                      <span className='fs-6'>{bookingItem?.Campamento}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Módulo: </span>
                      <span className='fs-6'>{bookingItem?.Modulo}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Piso: </span>
                      <span className='fs-6'>{bookingItem?.Nivel_descripcion}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Habitación: </span>
                      <span className='fs-6'>{bookingItem?.Habitacion}</span>
                    </div>
                    <div>
                      <span className='fw-bold fs-6'>Cama: </span>
                      <span className='fs-6'>{bookingItem?.CodigoCama}</span>
                    </div>
                  </div>
                ) : (
                  <div className='d-flex justify-content-center flex-column align-items-center'>
                    <div>
                      <img alt='Exito' src={toAbsoluteUrl('/media/logos/check.png')} />
                    </div>
                    <div className='d-flex flex-column align-items-center mt-3'>
                      <div className='fs-1 fw-bolder'>
                        Se encontro una reserva activa con checkin
                      </div>
                    </div>
                    {operationType === 'checkin' ? (
                      <div className='mt-3'>
                        <button type='button' onClick={handlePrintCheckin} className='sdx_btn'>
                          Reimprimir Ticket CheckIn
                        </button>
                      </div>
                    ) : (
                      <div className='mt-3'>
                        <button type='button' onClick={handlePrintCheckout} className='sdx_btn'>
                          Reimprimir CheckOut
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            <div className='d-flex flex-stack pt-15 justify-content-between'>
              <button
                type='button'
                className='btn btn-lg btn-light-primary me-3'
                data-kt-stepper-action='previous'
                onClick={handleGoStep2}
              >
                Atras
              </button>
              {!!!huespedId ? (
                <></>
              ) : (
                <button
                  type='button'
                  className='btn btn-lg btn-primary me-3'
                  onClick={handleSubmit}
                  disabled={isLoadingCheck}
                >
                  {!isLoadingCheck && (
                    <span className='indicator-label'>
                      {operationType === 'checkin' ? 'CheckIn' : 'CheckOut'}
                    </span>
                  )}
                  {isLoadingCheck && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {operationType === 'checkin' ? 'CheckIn...' : 'CheckOut...'}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              )}
            </div>
          </>
        )}
      </>
      <ModalPreviousCheckout
        show={showPreviousModal}
        onClose={handleClosePreviousModal}
        currentBooking={currentBookingData}
        previousBooking={previousBookingData}
        onConfirm={handleConfirmPreviousCheckout}
        loading={isModalLoading}
      />
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export {FormStep3}
